'use client';
import { useId } from 'react';
import { Gradient } from '../gradient';

export const Integrity = () => {
  const gradientId = useId();

  return (
    <>
      <Gradient gradientId={gradientId} />
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3451_22449)">
          <path
            d="M153.288 198.737C153.288 213.497 135.705 227.121 115.248 227.121C94.7915 227.121 77.1758 213.764 77.1758 198.737H153.288Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <g filter="url(#filter1_d_3451_22449)">
          <path
            d="M146.028 195.264C140.412 182.107 135.031 168.85 129.683 155.593C126.975 148.914 124.435 142.236 121.794 135.557L113.972 115.521H116.312L108.457 135.557C105.85 142.236 103.309 148.914 100.568 155.593C95.2199 168.95 89.8717 182.107 84.2227 195.264C88.9023 181.74 93.816 168.316 98.7631 154.892C101.203 148.213 103.81 141.535 106.351 134.856L113.972 114.82L115.142 111.748L116.312 114.82L123.933 134.856C126.44 141.535 129.047 148.213 131.488 154.892C136.368 168.316 141.382 181.74 146.028 195.264Z"
            fill="#2D5B5B"
          />
        </g>
        <g filter="url(#filter2_d_3451_22449)">
          <path
            d="M155.424 193.595H75V198.737H155.424V193.595Z"
            fill="#2D5B5B"
          />
        </g>
        <g filter="url(#filter3_d_3451_22449)">
          <path
            d="M322.824 233.284C322.824 248.044 305.275 261.635 284.784 261.635C264.293 261.635 246.711 248.445 246.711 233.284H322.824Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <path
          d="M276.248 259.188C276.248 259.188 264.024 255.345 258.435 249.822C256.213 247.626 255.054 246.25 253.436 243.579C251.652 240.634 249.998 235.462 249.998 235.462C249.998 235.462 252.124 240.462 254.109 243.287C255.886 245.816 257.121 247.08 259.373 249.198C264.95 254.444 276.248 259.188 276.248 259.188Z"
          fill="white"
        />
        <g filter="url(#filter4_d_3451_22449)">
          <path
            d="M315.605 229.813C309.956 216.656 304.574 203.399 299.259 190.108C296.518 183.43 293.978 176.751 291.337 170.072L283.515 150.036H285.855L278.033 170.072C275.393 176.751 272.852 183.43 270.145 190.108C264.796 203.466 259.415 216.823 253.766 229.813C258.445 216.289 263.359 202.831 268.34 189.44C270.78 182.762 273.387 176.083 275.894 169.404L283.515 149.368L284.685 146.263L285.855 149.368L293.477 169.404C295.984 176.083 298.591 182.762 301.031 189.44C305.878 202.831 310.925 216.289 315.605 229.813Z"
            fill="#2D5B5B"
          />
        </g>
        <g filter="url(#filter5_d_3451_22449)">
          <path
            d="M324.999 228.144H244.574V233.286H324.999V228.144Z"
            fill="#2D5B5B"
          />
        </g>
        <g filter="url(#filter6_d_3451_22449)">
          <path
            d="M283.643 149.938C278.896 149.367 276.187 146.288 271.216 143.507C263.759 139.459 234.405 132.631 221.506 131.092C216.361 130.446 204.902 132.855 197.322 131.34C189.741 129.825 180.097 123.196 175.101 121.805C162.525 118.254 132.848 113.288 124.347 114.133C118.506 114.704 114.902 116.616 110.329 115.225C102.872 113.139 104.165 102.313 113.734 104.225C123.303 106.137 125.689 108.571 138.341 110.88C143.809 111.873 176.965 114.604 186.162 116.442C190.77 117.212 195.257 118.581 199.509 120.514C204.165 120.37 208.819 120.838 213.353 121.904C222.574 123.742 254.19 133.997 259.658 135.164C272.086 137.895 275.367 136.579 284.936 138.516C294.505 140.453 291.299 150.881 283.643 149.938Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <g filter="url(#filter7_d_3451_22449)">
          <path
            d="M206.205 304.767H191.401C189.178 291.077 188.349 277.099 188.933 263.158C189.649 237.379 195.867 126.198 195.867 126.198H201.616C201.616 126.198 207.833 237.379 208.549 263.158C209.165 277.093 208.377 291.069 206.205 304.767Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <g filter="url(#filter8_d_3451_22449)">
          <path
            d="M258.588 304.263H137.842V324.996H258.588V304.263Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <g filter="url(#filter9_d_3451_22449)">
          <path
            d="M202.885 112.542C202.885 120.215 200.946 122.301 200.946 122.301H195.478C195.478 122.301 193.564 120.215 193.564 112.542C193.564 104.87 197.168 80.71 197.168 80.71H199.231C199.231 80.71 202.885 104.895 202.885 112.542Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <path
          d="M205.371 125.382C205.371 126.796 204.951 128.179 204.165 129.355C203.378 130.531 202.26 131.447 200.952 131.988C199.644 132.53 198.205 132.671 196.816 132.395C195.428 132.119 194.152 131.438 193.151 130.438C192.15 129.438 191.468 128.164 191.192 126.777C190.916 125.39 191.058 123.952 191.6 122.645C192.141 121.338 193.059 120.221 194.236 119.436C195.413 118.65 196.797 118.23 198.213 118.23C200.111 118.23 201.932 118.984 203.275 120.325C204.617 121.666 205.371 123.485 205.371 125.382Z"
          fill="#2D5B5B"
        />
        <g filter="url(#filter10_d_3451_22449)">
          <path
            d="M198.215 86.4219C201.372 86.4219 203.931 83.865 203.931 80.711C203.931 77.5569 201.372 75 198.215 75C195.057 75 192.498 77.5569 192.498 80.711C192.498 83.865 195.057 86.4219 198.215 86.4219Z"
            fill="#2D5B5B"
          />
        </g>
        <path
          d="M105.623 223.599C105.623 223.599 93.3988 219.756 87.8104 214.233C85.5883 212.037 84.4288 210.661 82.8105 207.99C81.0268 205.045 79.373 199.873 79.373 199.873C79.373 199.873 81.4994 204.873 83.484 207.698C85.2607 210.227 86.4963 211.491 88.7479 213.609C94.3248 218.855 105.623 223.599 105.623 223.599Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_3451_22449"
            x="71.1758"
            y="194.737"
            width="88.1113"
            height="40.3838"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_3451_22449"
            x="78.2227"
            y="107.748"
            width="73.8047"
            height="95.5156"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_3451_22449"
            x="69"
            y="189.595"
            width="92.4238"
            height="17.1426"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_d_3451_22449"
            x="240.711"
            y="229.284"
            width="88.1133"
            height="40.3506"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_d_3451_22449"
            x="247.766"
            y="142.263"
            width="73.8398"
            height="95.5498"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter5_d_3451_22449"
            x="238.574"
            y="224.144"
            width="92.4258"
            height="17.1426"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter6_d_3451_22449"
            x="99.5254"
            y="100"
            width="197.332"
            height="57.998"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter7_d_3451_22449"
            x="182.752"
            y="122.198"
            width="32"
            height="190.568"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter8_d_3451_22449"
            x="131.842"
            y="300.263"
            width="132.746"
            height="32.7334"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter9_d_3451_22449"
            x="187.564"
            y="76.71"
            width="21.3203"
            height="53.5908"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
          <filter
            id="filter10_d_3451_22449"
            x="186.498"
            y="71"
            width="23.4336"
            height="23.4219"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22449"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22449"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
